var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { AbfragerMultipleChoiceAnswerPart } from '../MultipleChoice/AbfragerMultipleChoiceAnswerPart';
import { AbfragerAssociateAssociationButton } from './AbfragerAssociateAssociationButton';
import { runtime } from '../../../../classes/runtime/Runtime';
import { Actor_ } from '../../../../components/actor/Actor_';
import { AbfragerQuestionAnswerPart } from '../../scenes/showQuestion/AbfragerQuestionAnswerPart';
let AbfragerAssociateAnswerPart = class AbfragerAssociateAnswerPart extends React.PureComponent {
    get flyingAssociation() {
        if (!runtime.isBrowserRuntime)
            return null;
        if (!this.props.question.currentAssociation)
            return null;
        const { style, isHidden } = this.props.question.currentAssociation.associationFly;
        if (isHidden)
            return null;
        return (React.createElement(Actor_, { actor: this.props.question.currentAssociation, structureTemplate: React.createElement("div", { style: style, "data-aspect": "fly" },
                React.createElement(AbfragerAssociateAssociationButton, { association: this.props.question.currentAssociation, className: this.props.question.currentAssociation.isAssociationComplete ? 'btn btn-success btn-lg' : undefined })) }));
    }
    render() {
        const { question } = this.props;
        return (React.createElement(AbfragerQuestionAnswerPart, { question: question },
            React.createElement(AbfragerMultipleChoiceAnswerPart, { question: question }),
            this.flyingAssociation));
    }
};
AbfragerAssociateAnswerPart = __decorate([
    observer
], AbfragerAssociateAnswerPart);
export { AbfragerAssociateAnswerPart };
